export default "__VITE_ASSET__dfc80eb9__"